import {ComponentInjector, ComponentSelector} from '@atypon/ui-utils';
import ClassicQuickSearch, {
    ClassicQuickSearchClassList,
    ClassicQuickSearchElements,
    ClassicQuickSearchSelectors
} from 'ui-theme/js/widgets/_quick-search';
import {QuickSearchTexts} from 'ui-core/widgets/quick-search/js/quick-search';

class Texts extends QuickSearchTexts {}

class ClassList extends ClassicQuickSearchClassList {}

class Selectors extends ClassicQuickSearchSelectors {
    citationJournalSelect = new ComponentSelector(".quick-search--citation__journal-select");
}

class Elements extends ClassicQuickSearchElements {}

interface QuickSearch {
    get elements(): Elements;
    get classList(): ClassList;
    get selectors(): Selectors;
    get texts(): Texts;
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class QuickSearch extends ClassicQuickSearch {

    protected async elementRenderer(item, data) {
        let ele;
        
        if (this.autoCompleteOptions.isSelectOnly === true) {
            ele = document.createElement('div');
        } else {
            ele = document.createElement('a');
            ele.href = data.value.url;
        }

        ele.className = "autoComplete__link--grid";
        ele.innerHTML = `<span class="autoComplete__text">${data.value.highlight}</span>`;
        // TODO, fix the global var declaration.
        // @ts-ignore
        if (data.value.paramFormatted && config.enableAutoCompleteCategory) {
            ele.innerHTML = `<span class='autoComplete__category'>${data.value.paramFormatted}</span> ${ele.innerHTML}`;
        }
        item.setAttribute('aria-label', ele.innerText);
        item.innerHTML = '';
        
        // to append hidden inputs values to search params to autocomplete links; to filter results as required
        await item.appendChild(ele);
        const formHiddenInputs = ele.closest('.quick-search__input').querySelectorAll('input[type=hidden]');
        const url = new URL(ele.href);
        const params = new URLSearchParams(url.search);
        formHiddenInputs.forEach(input => {
            input.name === "PubTypeOr" ? params.append(input.name, input.value) : params.set(input.name, input.value)
        });
        ele.href = url.pathname + '?' + params.toString()
    }
}

export default QuickSearch;

export {
    Selectors as QuickSearchSelectors,
    Elements as QuickSearchElements,
    ClassList as QuickSearchClassList,
    Texts as QuickSearchTexts,
};